import AutoComplete from "../ui/AutoComplete.js";
import Container from '../Container';

import autobind from "autobind-decorator";
import PropTypes from 'prop-types';
import React, {Component} from "react";

class AutoCompleteElement extends Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        values: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static displayName = 'AutoComplete';

    @autobind
    handleChange() {
        let newValue = this._autoComplete.get() || "";
        let oldValue = this.props.value;

        if (newValue !== oldValue) {
            this.props.onChange({value: newValue, key: this.props.name});
        }
    }

    valuesToKeys(values) {
        let obj = new Container();
        values.forEach(value => obj.set(value));
        return obj;
    }

    componentDidUpdate(oldProps) {
        var data = this.valuesToKeys(this.props.values);
        this._autoComplete.setData(data);
        this._autoComplete.set(this.props.value);
    }

    componentWillUnmount() {
        this._autoComplete.destroy();
    }

    componentDidMount() {
        this._autoComplete = new AutoComplete(this.el);
        this._autoComplete.listen("commit", this.handleChange);
        this.componentDidUpdate();
    }

    render() {
        return <div ref={node => this.el = node} className="autocomplete"></div>;
    }
}
export default AutoCompleteElement;



// WEBPACK FOOTER //
// ./src/abusesa-js/components/AutoComplete.jsx